import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { GlobalService } from './global.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { Funcionario } from '../models/funcionario';
import { GestaoDesconto } from '../models/gestao-desconto';
import { TelaDoFuncionario } from '../models/tela-do-funcionario';
import { FiltroDA } from '../models/atualizaDA';
import { RelatorioDoFuncionario } from '../models/relatorio-do-funcionario';

@Injectable({
  providedIn: 'root'
})
export class FuncionarioService {
  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) {}

  consultarFuncionarios(todos?, somenteAtivos?, somenteBloqueados?, vendedor?) {
    let parametros = new HttpParams();

    if (todos) {
      parametros = parametros.set('todos', todos.toString());
    }

    if (!todos && somenteAtivos) {
      parametros = parametros.set('somenteAtivos', somenteAtivos.toString());
    }

    if (!todos && somenteBloqueados) {
      parametros = parametros.set('somenteBloqueados', somenteBloqueados.toString());
    }

    if (vendedor) {
      parametros = parametros.set('vendedor', vendedor);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/Lista', { params: parametros });
  }

  consultarFuncionariosContatos(todos?) {
    let parametros = new HttpParams();
    if (todos !== undefined && todos !== null) {
      parametros = parametros.set('todos', todos.toString());
    }

    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/ListaParaContatos', { params: parametros });
  }

  consultarLimitDesc(idFuncion) {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/BuscarLimDesc', {
      params: new HttpParams().set('id', idFuncion.toString())
    });
  }

  consultarFuncionariosPedido(todos?: boolean, somenteAtivos?: boolean) {
    let parametros = new HttpParams();
    if (todos !== undefined && todos !== null) {
      parametros = parametros.set('todos', todos.toString());
    }

    if (somenteAtivos !== undefined && somenteAtivos !== null) {
      parametros = parametros.set('somenteAtivos', somenteAtivos.toString());
    }

    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/ListaPedido', {
      params: parametros
    });
  }

  consultarFuncionariosPedidoSimples(todos?: boolean, somenteAtivos?: boolean) {
    let parametros = new HttpParams();
    if (todos !== undefined && todos !== null) {
      parametros = parametros.set('todos', todos.toString());
    }

    if (somenteAtivos !== undefined && somenteAtivos !== null) {
      parametros = parametros.set('somenteAtivos', somenteAtivos.toString());
    }

    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/ListaPedidoSimples', {
      params: parametros
    });
  }

  consultarFuncionariosInclusive(ids) {
    return this.http.post<any>(globals.apiUrl + '/api/Funcionario/ListaInclusive', ids);
  }

  consultarFuncionariosComPaginacao(
    descricao: string,
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    ativo,
    participaDoFunil,
    perfilDeAcesso
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (ativo !== undefined && ativo !== null) {
      parametros = parametros.set('ativo', ativo);
    }

    if (perfilDeAcesso !== undefined && perfilDeAcesso !== null) {
      parametros = parametros.set('perfilDeAcesso', perfilDeAcesso);
    }

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    if (participaDoFunil) {
      parametros = parametros.set('participaDoFunil', participaDoFunil.toString());
    }

    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/ListaPag', {
      params: parametros
    });
  }

  salvarMonitoramentos(monitoramentos) {
    return this.http.post<any>(globals.apiUrl + '/api/Funcionario/SalvarMonitoramentos', monitoramentos);
  }

  buscarMonitoramentos(idFuncionario) {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/BuscarMonitoramentos', {
      params: new HttpParams().set('idFuncionario', idFuncionario)
    });
  }

  consultarFuncionarioPorId(id) {
    return this.http.get<Funcionario>(globals.apiUrl + '/api/Funcionario/Buscar', {
      params: new HttpParams().set('id', id)
    });
  }

  consultarFuncionarioPorIdSimples(id) {
    return this.http.get<Funcionario>(globals.apiUrl + '/api/Funcionario/BuscarSimples', {
      params: new HttpParams().set('id', id)
    });
  }

  consultarNome(id) {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/BuscarNome', {
      params: new HttpParams().set('id', id)
    });
  }

  salvar(funcionario: Funcionario) {
    return this.http.post(globals.apiUrl + '/api/Funcionario/Salvar', funcionario);
  }

  bloquear(id) {
    return this.http.delete(globals.apiUrl + '/api/Funcionario/Bloquear', { params: new HttpParams().set('id', id) });
  }

  alterarFunilPadrao(idUsuario, idFunil) {
    return this.http.post(
      globals.apiUrl + '/api/Funcionario/AlterarFunilPadrao',
      {},
      { params: new HttpParams().set('idUsuario', idUsuario).set('idFunil', idFunil) }
    );
  }

  alterarLiderTime(idLiderAntigo, idSuperiorLiderAntigo, idLiderNovo) {
    return this.http.post(
      globals.apiUrl + '/api/Funcionario/AlterarLiderTime',
      {},
      {
        params: new HttpParams()
          .set('idLiderAntigo', idLiderAntigo)
          .set('idSuperiorLiderAntigo', idSuperiorLiderAntigo)
          .set('idLiderNovo', idLiderNovo)
      }
    );
  }

  consultarTodosFuncionarios() {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/ListarTodos');
  }

  consultarFuncionarioPorIdCupom(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/ListarPorIdCupom', {
      params: new HttpParams().set('idCupom', idCupom)
    });
  }

  consultarGestaoDesconto() {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/BuscarGestaoDesconto');
  }

  salvarGestaoDesconto(gestao: GestaoDesconto) {
    return this.http.post(globals.apiUrl + '/api/Funcionario/SalvarGestaoDesconto', gestao);
  }

  salvarFiltroGestaoDesconto(filtro: FiltroDA) {
    return this.http.post(globals.apiUrl + '/api/Funcionario/SalvarFiltroGestaoDesconto', filtro);
  }

  consultarFiltrosGestaoDesconto(idUsuario) {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/BuscarFiltroGestaoDesconto', {
      params: new HttpParams().set('idUsuario', idUsuario)
    });
  }

  consultarFiltroComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, idUsuario) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('idUsuario', idUsuario);

    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/FiltroListaPag', {
      params: parametros
    });
  }

  consultarLogFiltroGestaoDescComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, idUsuario) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('idUsuario', idUsuario);

    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/BuscarLogFiltroGestaoDesc', {
      params: parametros
    });
  }

  excluirFiltros(filtro) {
    return this.http.post(globals.apiUrl + '/api/Funcionario/ExcluirFiltro', filtro);
  }

  ConsultarVendedorDoIntegrador() {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/BuscarVendedorDoIntegrador');
  }

  consultarTelasDoFuncionario() {
    return this.http.get<TelaDoFuncionario[]>(globals.apiUrl + '/api/Funcionario/TelasDoFuncionario');
  }

  consultarRelatoriosDoFuncionario() {
    return this.http.get<RelatorioDoFuncionario>(globals.apiUrl + '/api/Funcionario/RelatoriosDoFuncionario');
  }

  possuiAcessoNaTela(sistema, tela, pai, idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/PossuiAcessoNaTela', {
      params: new HttpParams()
        .set('sistema', sistema)
        .set('tela', tela)
        .set('pai', pai === null ? '' : pai)
        .set('idCupom', idCupom)
    });
  }

  possuiAcessoNoRelatorio() {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/PossuiAcessoNoRelatorio');
  }

  consultarPermissoesPedido() {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/PermissoesPedido');
  }

  consultarIdCDPadrao() {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/BuscarIdCDPadrao');
  }

  consultarPodeGerarCombAut() {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/PodeGerarCombAut');
  }

  consultarPodeAlterarEstoque() {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/PodeAlterarEstoque');
  }

  consultarPodeAlterarVendedor() {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/PodeAlterarVendedor');
  }

  consultaPodeVerGestaoAvancada(id) {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/PodeVerGestaoAvancada', {
      params: new HttpParams().set('id', id)
    });
  }

  consultaPodeVerEstoque(id) {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/PodeVerEstoque', {
      params: new HttpParams().set('id', id)
    });
  }

  transferirItemsVendedor(vm) {
    return this.http.post<any>(globals.apiUrl + '/api/Funcionario/TransferirItemsVendedor', vm);
  }

  consultaPodeAcessarCadastroIntegrador(id) {
    return this.http.get<any>(globals.apiUrl + '/api/Funcionario/PodeAcessarCadastroIntegrador', {
      params: new HttpParams().set('id', id)
    });
  }

  consultaPodeAlterarCD() {
    return this.http.get<boolean>(globals.apiUrl + '/api/Funcionario/PodeAlterarCD');
  }

  alterarCDEmMassa(habilitar) {
    return this.http.post<any>(
      globals.apiUrl + '/api/Funcionario/AlterarCDEmMassa',
      {},
      { params: new HttpParams().set('habilitar', habilitar) }
    );
  }

  consultaPodeVerAnaliseCredito() {
    return this.http.get<boolean>(globals.apiUrl + '/api/Funcionario/PodeVerAnaliseCredito');
  }
}
